
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.696","height":"24.696","viewBox":"0 0 24.696 24.696"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_7","data-name":"Group 7","transform":"translate(-67.497 -132.919)"}},[_c('g',{attrs:{"id":"Group_6","data-name":"Group 6"}},[_c('path',{attrs:{"id":"Path_6","data-name":"Path 6","d":"M92.193,145.267a12.348,12.348,0,1,0-14.278,12.2v-8.629H74.78v-3.569h3.135v-2.721c0-3.094,1.844-4.8,4.664-4.8a19.022,19.022,0,0,1,2.765.241v3.039H83.786a1.785,1.785,0,0,0-2.012,1.929v2.316H85.2l-.548,3.569H81.774v8.629A12.351,12.351,0,0,0,92.193,145.267Z","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_7","data-name":"Path 7","d":"M84.651,148.836l.548-3.569H81.774v-2.316a1.785,1.785,0,0,1,2.012-1.929h1.558v-3.039a19.022,19.022,0,0,0-2.765-.241c-2.82,0-4.664,1.71-4.664,4.8v2.721H74.78v3.569h3.135v8.629a12.484,12.484,0,0,0,3.859,0v-8.629Z","fill":"#fd7e14"}})])])])
          )
        }
      }
    